import React, { useEffect, useRef, useState } from 'react'
import { useCombobox } from 'downshift'
import clx from 'classnames'
import { ArrowIcon } from "./ArrawIcon";

function itemToString(item) {
  if (item == null) {
    return ''
  }
  if (item?.city == null) {
    return item?.title ?? ''
  }
  return item?.city + ' ' + item?.title
}

export function SuperSelect({ onChange, locations, location, defaultValue = null }) {
  const items = locations

  const [inputValue, setInputValue] = useState('')
  const [inputItems, setInputItems] = useState(items)
  const [_selectedItem, setSelectedItem] = useState(location)
  const toggleButtonRef = useRef(null)
  const selectedItem = _selectedItem ?? defaultValue

  useEffect(() => {
    onChange(selectedItem)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem?.id])

  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
    getInputProps
  } = useCombobox({
    items: inputItems,
    selectedItem,
    itemToString,
    onSelectedItemChange(changes) {
      setInputValue('')
      setInputItems(items)
      setSelectedItem(changes.selectedItem ?? null)
      toggleButtonRef.current?.focus()
      return changes
    }
  })

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      <button
        type='button'
        className={clx('select_button', { is_open: isOpen })}
        {...getToggleButtonProps({
          ref: toggleButtonRef,
          tabIndex: 0
        })}
      >
        <span
          dangerouslySetInnerHTML={{ __html: selectedItem ? itemToString(selectedItem) : 'Vælg forhandler' }}
          style={{ flex: 1 }}
        />
        <ArrowIcon/>
      </button>
      <div className={clx('select_menu_outer', { is_open: isOpen })}>
        <input
          type='text'
          className={clx('select_input', { 'visually-hidden-style': !isOpen })}
          {...getInputProps({
            value: inputValue,
            onChange: ({ currentTarget: { value: inputValue } }) => {
              setInputValue(inputValue)
              setInputItems(
                items.filter(
                  (item) =>
                    inputValue == null ||
                    itemToString(item)
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                )
              )
            },
            tabIndex: -1
          })}
        />
        <ul className={clx('select_menu_list')} {...getMenuProps()}>
          {isOpen &&
            inputItems.map((item, index) => {
              const isActive = highlightedIndex === index
              const isSelected = selectedItem === item
              return (
                <li
                  key={`${item.id}${index}`}
                  className={clx('select_menu_list_item', { is_selected: isSelected, is_active: isActive })}
                  {...getItemProps({
                    item,
                    index
                  })}
                  dangerouslySetInnerHTML={{ __html: itemToString(item) }}
                />
              )
            })}
        </ul>
      </div>
    </div>
  )
}
